import clsx from "clsx";
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";

import Input from "~/components/common/input";
import { setParam } from "~/redux/action-creaters/cart";
import { UserFields } from "~/types/cart";

import styles from "./index.module.scss";

const items = [
  {
    name: "Я получатель",
    icon: (
      <svg
        width="18"
        height="20"
        viewBox="0 0 18 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M17 19C17 17.6044 17 16.9067 16.8278 16.3389C16.44 15.0605 15.4395 14.06 14.1611 13.6722C13.5933 13.5 12.8956 13.5 11.5 13.5H6.5C5.10444 13.5 4.40665 13.5 3.83886 13.6722C2.56045 14.06 1.56004 15.0605 1.17224 16.3389C1 16.9067 1 17.6044 1 19M13.5 5.5C13.5 7.98528 11.4853 10 9 10C6.51472 10 4.5 7.98528 4.5 5.5C4.5 3.01472 6.51472 1 9 1C11.4853 1 13.5 3.01472 13.5 5.5Z"
          stroke="#1247A5"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    ),
  },
  {
    name: "Получит другой человек",
    icon: (
      <svg
        width="22"
        height="20"
        viewBox="0 0 22 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M11 13.5H6.5C5.10444 13.5 4.40665 13.5 3.83886 13.6722C2.56045 14.06 1.56004 15.0605 1.17224 16.3389C1 16.9067 1 17.6044 1 19M18 19V13M15 16H21M13.5 5.5C13.5 7.98528 11.4853 10 9 10C6.51472 10 4.5 7.98528 4.5 5.5C4.5 3.01472 6.51472 1 9 1C11.4853 1 13.5 3.01472 13.5 5.5Z"
          stroke="#1247A5"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    ),
  },
];
export default function Recipient() {
  const dispatch = useDispatch();
  const { params, isParamsLoaded } = useSelector((state: any) => state.cart);

  useEffect(() => {
    if (isParamsLoaded && !params[UserFields.recipient]) {
      dispatch(
        setParam({
          ...params,
          [UserFields.recipient]: items[0].name,
        }),
      );
    }
  }, [params, isParamsLoaded]);
  return (
    <div>
      <div className={styles.Title}>Выберите получателя</div>

      <div className={styles.Items}>
        {items.map((item: any) => (
          // eslint-disable-next-line jsx-a11y/click-events-have-key-events,jsx-a11y/label-has-associated-control,jsx-a11y/no-noninteractive-element-interactions
          <label
            key={item.name}
            className={clsx(
              styles.Item,
              params[UserFields.recipient]?.includes(item.name) &&
                styles.Active,
            )}
            onClick={() => {
              dispatch(
                setParam({ ...params, [UserFields.recipient]: item.name }),
              );
            }}
          >
            <div className={styles.Icon}>{item.icon}</div>
            <div>{item.name}</div>
          </label>
        ))}
      </div>

      {params[UserFields.recipient]?.includes(items[1].name) && (
        <div className={styles.Name}>
          <Input
            value={params[UserFields.recipient]?.split(": ")?.[1]}
            placeholder="Имя и фамилия (как в документах)"
            onChange={(val: any) => {
              dispatch(
                setParam({
                  ...params,
                  [UserFields.recipient]: `${items[1].name}: ${val}`,
                }),
              );
            }}
          />
        </div>
      )}
    </div>
  );
}
